

// import { toast } from "react-toastify";
// // import { useNavigate } from "react-router-dom";

// export const handleUnauthorized = (navigate) => {
//   localStorage.removeItem("auth");
//   toast.error("Session expired. Please log in again.", {
//     toastId: "session-expired",
//   });
//   navigate("/");
// };

// export const handleError = (error) => {
//   const status = error.response?.status;
//   const message =
//     error.response?.data?.message || "An unexpected error occurred.";

//   if (status === 204) {
//     toast.error(message, { toastId: "notfound-error" });
//   } else if (status === 400) {
//     toast.error(message, { toastId: "bad-request" });
//   } else if (status === 401) {
//     handleUnauthorized();
//   } else if (status === 403) {
//     toast.error(message, {
//       toastId: "unauthorized-access",
//     });
//   } else if (status === 404) {
//     toast.error(message, {
//       toastId: "unauthorized-access",
//     });
//   } else if (status === 500) {
//     toast.error(message, { toastId: "server-error" });
//   } else {
//     toast.error(message, { toastId: "default-error" });
//   }
// };


import { toast } from "react-toastify";

export const handleUnauthorized = (navigate) => {
  localStorage.removeItem("auth");
  toast.error("Session expired. Please log in again.", {
    toastId: "session-expired",
  });

  if (typeof navigate === "function") {
    navigate("/"); // safely redirect
  } else {
    console.log("Can  not navigate now....");
  }
};

export const handleError = (error, navigate) => {
  const status = error?.response?.status;
  const message =
    error?.response?.data?.message || "An unexpected error occurred.";

  if (status === 204) {
    toast.error(message, { toastId: "notfound-error" });
  } else if (status === 400) {
    toast.error(message, { toastId: "bad-request" });
  } else if (status === 401 || status === "401") {
    handleUnauthorized(navigate);
  } else if (status === 403) {
    toast.error(message, { toastId: "unauthorized-access" });
  } else if (status === 404) {
    toast.error(message, { toastId: "not-found" });
  } else if (status === 500) {
    toast.error(message, { toastId: "server-error" });
  } else {
    toast.error(message, { toastId: "default-error" });
  }
};
